/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { Button, Paper, Grid, Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import './FAQS.scss';
import { getCookie } from '../../utils/Communicator';
import { useDispatch, useSelector } from 'react-redux';
import { snackbarToggle } from '../../reducers/snackbarSlicer';
import account_banner from '../../images/homepage/account_banner.png';
import userPng from '../../images/homepage/user.png';
import ActionButton from '../Common/ActionButton';
import address from '../../images/homepage/address.png'
import tracking from '../../images/homepage/tracking.png'
import calculator from '../../images/homepage/calculator.png'
import ShopingOne from '../../images/faq/one-man.png';
import ShopingTwo from '../../images/faq/man-woman-shipping.png';
import BlueBoxGirl from '../../images/faq/blueBoxGirl.png';
import Stopwatch from '../../images/faq/stopwatch.svg';
import Signup_1 from '../../images/faq/signup-1.png';
import ShopingStart_2 from '../../images/faq/shopingStart-2.png';
import ShipmentOnWay_4 from '../../images/faq/payment-3.png';
import Payment_3 from '../../images/faq/shipmentOnWay-4.png';
import pdf from '../../files/approval.pdf';
import queryString from 'query-string';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { get_params } from '../../reducers/requestHandler';
import MetaTags from 'react-meta-tags';

export const Howto = (props) => {
    const { setActiveScreenInreg, setIsRegister, setIsLogin } = props;
    const { userInfo, innerContent } = useSelector(state => state.user);
    const { snackbar } = useSelector(state => state.snackbar);
    //const navigate = useNavigate();
    const onSnackbarHandleClose = () => dispatch(snackbarToggle(false));

    const vnavigate = useNavigate();
    const navigate = function (url) {
        vnavigate(url);
        window.scrollTo(0,0);
    }
    const [userName, setUserName] = new useState("");
    const [password, setPassword] = new useState("");
    const [session, setSession] = new useState(getCookie("SESSION_ID"));
    const [isEnable, setEnabled] = new useState(true);
    const [isPackageLoaded, setPackageLoaded] = new useState(false);
    const [hasError, setHasError] = new useState(false);
    const dispatch = useDispatch();
    const failedCallback = useCallback(message => dispatch(snackbarToggle({ type: 'error', message })), [dispatch]);
    const [isLoaded, setIsLoaded] = useState(true);
    const [isSubFilter, setIsSubFilter] = useState(false);
    
    const isMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const [expanded, setExpanded] = useState('');
    const handleChange = (panel) => (isExpanded) => {
        if (expanded === panel) {
            setExpanded(false);
        }
        else {
            setExpanded(isExpanded ? panel : false);
        }

    };
    const location = useLocation();
    useEffect(() => {
        
        if (location?.state?.name == "forbidden_for_flight") {
            document.getElementById('forbidden_for_flight').scrollIntoView();
            handleChange('29');
        }
        if (location?.state?.name == "forbidden_for_import") {
            document.getElementById('forbidden_for_import').scrollIntoView();
            handleChange('30');
        }
        if (location?.state?.name == "from_registration") {
            document.getElementById('from_registration').scrollIntoView();
        }
        if (location?.state?.name == "fromRightContentBelowPricing") {
            document.getElementById('more_info_41').scrollIntoView(); 
            //document.getElementById('fromRightContentBelowPricing').scrollIntoView();
        }
        if (location?.state?.name == "faqList") {
            document.getElementById('faqList').scrollIntoView();
        }
        var action = get_params("action")
        if (action === "from_registration") {
            document.getElementById('from_registration').scrollIntoView();
        }
        if (action === "forbidden_for_flight") {
            document.getElementById('forbidden_for_flight').scrollIntoView();
            handleChange('29');
        }
        if (action === "forbidden_for_import") {
            document.getElementById('forbidden_for_import').scrollIntoView();
            handleChange('30');
        }
        let searchParams = queryString.parse(location.search)
        try {
            console.log(searchParams.id)
            document.getElementById(searchParams.id).scrollIntoView();
            window.setTimeout(function () {
                document.getElementById(searchParams.id).scrollIntoView();
            }, 500)
           
            if (searchParams.id == "consolidationlinkTarget")
                setExpanded('246');
        } catch (e) { }
        // }
    }, [userInfo]);
    return (
        <>
            <MetaTags id="metaFAQ">
                <title>הכל על השירות שלנו</title>
                <meta id="meta-description" name="FAQS" content='הכל על השירות שלנו' />
                <meta id="meta-description-title" property="og:title" content="Redbox parcel" />
            </MetaTags>
            <Box>
                <Box component={'section'} className="faq-section" style={{ padding: '30px 0' }}>
                    {!isMobile() && <Box className="container">
                        
                        {/*<Grid container className='fillter-tabs'>
                            <ul className='tabs-list'>
                                <li className={!isSubFilter ? 'active':''} ><a href="#">איך זה עובד?</a></li>
                                <li onClick={() => {
                                    document.getElementById('faqList').scrollIntoView();
                                }}><a >שאלות ותשובות</a></li>
                                */}{/*<li className={isSubFilter ? 'active' : ''} onClick={() => {  document.getElementById('more_info').scrollIntoView(); }}><a >מדריכים</a></li>*/}{/*
                            </ul>
                        </Grid>*/}
                        

                        <Typography component={'h1'} className='section-title mb-60'>איך עובד תהליך ההרשמה והרכישה ב- RedBox?</Typography>
                        {/* Step 1 */}
                        <Grid container className='box-wrapper'>
                            <Grid item sm={5} className='blue-rounded-box redbox-one'>
                                <img src={Signup_1} alt='' style={{ borderRadius: "10px" }} />
                            </Grid>
                            <Grid container item sm={8} className='darkblue-rounded-box white_box shadow_box dir-rtl'>
                                <Grid container item sm={2} sx={{ alignItems: 'flex-start'}}>
                                    <Typography className='step_no' component={'h2'}>{/*1*/}</Typography>
                                </Grid>
                                <Grid item sm={8}>
                                    <Typography className='step_title' component={'h2'}>נרשמים</Typography>
                                    <Typography className='step_desc'>{`בתהליך הרשמה קצר מצטרפים לשירות ומקבלים כתובת אישית בחו"ל בחינם.`}</Typography>
                                    <ActionButton textLabel={`הירשמו בחינם`} className='underline-btn red_text' onClick={() => {
                                        if (userInfo.session) {
                                            navigate("/accounts")
                                        } else {
                                            setActiveScreenInreg('Registeration'); setIsRegister(true);
                                        }
                                    }} />
                                </Grid>
                                {/*<Grid item sm={2}>
                                    <Grid container className='stopwatch'>
                                        <img src={Stopwatch} alt='' />
                                        {`3 דקות`}
                                    </Grid>
                                </Grid>*/}
                            </Grid>
                        </Grid>
                        {/* Step 2 */}
                        <Grid container className='box-wrapper dir-rtl'>
                            <Grid container item sm={9} className='darkblue-rounded-box white_box shadow_box dir-rtl'>
                                <Grid container item sm={1} sx={{ alignItems: 'flex-start'}}>
                                    <Typography className='step_no' component={'h2'}>{/*2*/}</Typography>
                                </Grid>
                                <Grid item sm={8}>
                                    <Typography className='step_title' component={'h2'}>{`מתחילים בקניות`}</Typography>
                                    <Typography className='step_desc'>{`קונים בחנות המועדפת עליכם ובהשלמת הרכישה מזינים את הכתובת האישית שקיבלתם ככתובת המשלוח.`}</Typography>
                                    {/*<Typography className='anchor link-text cursor_pointer' onClick={() => { navigate("/store") }}>{`לרשימת החנויות המומלצות`}{` >`}</Typography>*/}
                                    <ActionButton textLabel={`לרשימת החנויות המומלצות`} className='underline-btn red_text' onClick={() => {
                                        navigate("/store")
                                    }} />
                                </Grid>
                                {/*<Grid item sm={3}>
                                    <Grid container className='stopwatch align-right'>
                                        <img src={Stopwatch} alt='' />
                                        {`תלוי בכם`}
                                    </Grid>
                                </Grid>*/}
                            </Grid>
                            <Grid item sm={5} className='blue-rounded-box redbox-two'>
                                <img src={ShopingStart_2} alt='' style={{ borderRadius: "10px" }} />
                            </Grid>
                        </Grid>
                        {/* Step 3 */}
                        <Grid container className='box-wrapper'>
                            <Grid item sm={5} className='blue-rounded-box redbox-three'>
                                <img src={Payment_3} alt='' style={{ borderRadius: "10px" }} />
                            </Grid>
                            <Grid container item sm={9} className='darkblue-rounded-box white_box shadow_box dir-rtl'>
                                <Grid container item sm={3} sx={{ alignItems: 'flex-start'}}>
                                    <Typography className='step_no' component={'h2'}>{/*3*/}</Typography>
                                </Grid>
                                <Grid item sm={8}>
                                    <Typography className='step_title' component={'h2'}>{`משלמים`}</Typography>
                                    <Typography className='step_desc'>{`כשהחבילה מגיעה אלינו תקבלו הודעה ובכמה שלבים מהירים תבחרו את אופן המשלוח המתאים לכם ותשלימו את התשלום.`}</Typography>
                                    
                                </Grid>
                                {/*<Grid item sm={2}>
                                    <Grid container className='stopwatch'>
                                        <img src={Stopwatch} alt='' />
                                        {`4 דקות`}
                                    </Grid>
                                </Grid>*/}
                            </Grid>
                        </Grid>
                        {/* Step 4 */}
                        <Grid container className='box-wrapper dir-rtl'>
                            <Grid container item sm={9} className='darkblue-rounded-box white_box shadow_box dir-rtl'>
                                <Grid container item sm={1} sx={{ alignItems: 'flex-start'}}>
                                    <Typography className='step_no' component={'h2'}>{/*4*/}</Typography>
                                </Grid>
                                <Grid item sm={8}>
                                    <Typography className='step_title' component={'h2'}>{`המשלוח בדרך אליכם`}</Typography>
                                    <Typography className='step_desc'>{`אנו נדאג לקליטת החבילה בארץ ואתם תהנו ממשלוח שיגיע אליכם עד הבית!`}</Typography>
                                    
                                </Grid>
                                {/*<Grid item sm={3}>
                                    <Grid container className='stopwatch align-right'>
                                        <img src={Stopwatch} alt='' />
                                        {`עד 5 ימי עסקים`}
                                    </Grid>
                                </Grid>*/}
                            </Grid>
                            <Grid item sm={5} className='blue-rounded-box redbox-four' >
                                <img src={ShipmentOnWay_4} alt='' style={{ borderRadius: "10px" }} />
                            </Grid>
                            
                        </Grid>
                        <span id="faqList"></span>
                    </Box>}
                    {isMobile() && < Box className="container">
                        
                        {/*<Grid container className='fillter-tabs'>
                            <ul className='tabs-list'>
                                <li className={!isSubFilter ? 'active' : ''} ><a href="#">איך זה עובד?</a></li>
                                <li onClick={() => {
                                    document.getElementById('faqList').scrollIntoView();
                                }}><a >שאלות ותשובות</a></li>
                                */}{/*<li className={isSubFilter ? 'active' : ''} onClick={() => { document.getElementById('more_info').scrollIntoView(); }}><a >מדריכים</a></li>*/}{/*
                            </ul>
                        </Grid>*/}


                        <Typography component={'h1'} className='section-title mb-60'>איך עובד תהליך ההרשמה והרכישה ב- RedBox?</Typography>
                        {/* Step 1 */}
                        <Grid container className='box-wrapper' flexDirection="column" alignItems="center">
                           
                            <Grid container item sm={8} className='darkblue-rounded-box white_box shadow_box dir-rtl'>
                                <Grid container item sm={2} sx={{ alignItems: 'flex-start' }}>
                                    <Typography className='step_no' component={'h2'}>1</Typography>
                                </Grid>
                                <Grid item sm={8} container justifyContent="center">
                                    <Typography className='step_title' component={'h2'}>נרשמים</Typography>
                                    <Typography className='step_desc'>{`בתהליך הרשמה קצר מצטרפים לשירות ומקבלים כתובת אישית בחו"ל בחינם.`}</Typography>
                                    <ActionButton textLabel={`הירשמו בחינם`} className='underline-btn red_text' onClick={() => {
                                        if (userInfo.session) {
                                            navigate("/accounts")
                                        } else {
                                            setActiveScreenInreg('Registeration'); setIsRegister(true);
                                        }
                                    }} />
                                </Grid>
                                {/*<Grid item sm={2}>
                                    <Grid container className='stopwatch'>
                                        <img src={Stopwatch} alt='' />
                                        {`3 דקות`}
                                    </Grid>
                                </Grid>*/}
                            </Grid>
                            <Grid item sm={5} >
                                <img src={Signup_1} alt='' style={{ borderRadius: "10px" }} />
                            </Grid>
                        </Grid>
                        {/* Step 2 */}
                        <Grid container className='box-wrapper dir-rtl' flexDirection="column" alignItems="center">
                            <Grid container item sm={9} className='darkblue-rounded-box white_box shadow_box dir-rtl'>
                                <Grid container item sm={1} sx={{ alignItems: 'flex-start' }}>
                                    <Typography className='step_no' component={'h2'}>2</Typography>
                                </Grid>
                                <Grid item sm={8} container justifyContent="center">
                                    <Typography className='step_title' component={'h2'}>{`מתחילים בקניות`}</Typography>
                                    <Typography className='step_desc'>{`קונים בחנות המועדפת עליכם ובהשלמת הרכישה מזינים את הכתובת האישית שקיבלתם ככתובת המשלוח.`}</Typography>
                                    {/*<Typography className='anchor link-text cursor_pointer' onClick={() => { navigate("/store") }}>{`לרשימת החנויות המומלצות`}{` >`}</Typography>*/}
                                    <ActionButton textLabel={`לרשימת החנויות המומלצות`} className='underline-btn red_text' onClick={() => {
                                        navigate("/store")
                                    }} />
                                </Grid>
                                {/*<Grid item sm={3}>
                                    <Grid container className='stopwatch align-right'>
                                        <img src={Stopwatch} alt='' />
                                        {`תלוי בכם`}
                                    </Grid>
                                </Grid>*/}
                            </Grid>
                            <Grid item sm={5} >
                                <img src={ShopingStart_2} alt='' style={{ borderRadius: "10px" }} />
                            </Grid>
                        </Grid>
                        {/* Step 3 */}
                        <Grid container className='box-wrapper'  alignItems="center">
                            
                            <Grid container item sm={9} className='darkblue-rounded-box white_box shadow_box dir-rtl'>
                                <Grid container item sm={3} sx={{ alignItems: 'flex-start' }}>
                                    <Typography className='step_no' component={'h2'}>3</Typography>
                                </Grid>
                                <Grid item sm={8} container justifyContent="center">
                                    <Typography className='step_title' component={'h2'}>{`משלמים`}</Typography>
                                    <Typography className='step_desc'>{`כשהחבילה מגיעה אלינו תקבלו הודעה ובכמה שלבים מהירים תבחרו את אופן המשלוח המתאים לכם ותשלימו את התשלום.`}</Typography>

                                </Grid>
                                {/*<Grid item sm={2}>
                                    <Grid container className='stopwatch'>
                                        <img src={Stopwatch} alt='' />
                                        {`4 דקות`}
                                    </Grid>
                                </Grid>*/}
                            </Grid>
                            <Grid item sm={5} >
                                <img src={Payment_3} alt='' style={{ borderRadius: "10px" }} />
                            </Grid>
                        </Grid>
                        {/* Step 4 */}
                        <Grid container className='box-wrapper dir-rtl' flexDirection="column" alignItems="center">
                            <Grid container item sm={9} className='darkblue-rounded-box white_box shadow_box dir-rtl'>
                                <Grid container item sm={1} sx={{ alignItems: 'flex-start' }}>
                                    <Typography className='step_no' component={'h2'}>4</Typography>
                                </Grid>
                                <Grid item sm={8} container justifyContent="center">
                                    <Typography className='step_title' component={'h2'}>{`המשלוח בדרך אליכם`}</Typography>
                                    <Typography className='step_desc'>{`אנו נדאג לקליטת החבילה בארץ ואתם תהנו ממשלוח שיגיע אליכם עד הבית!`}</Typography>

                                </Grid>
                            </Grid>
                            <Grid item sm={5}  >
                                <img src={ShipmentOnWay_4} alt='' style={{ borderRadius: "10px" }} />
                            </Grid>

                        </Grid>
                        <span id="faqList"></span>
                    </Box>}
                </Box>


                <Box component={'section'} className="faq-section dir-rtl" style={{ padding: '30px 0', fontSize:"20px" }}>
                    <Box className="container">
                        <p>{`לתנאי שימוש לחץ `}<span><a href="/TnC.pdf">{`כאן`}</a></span></p>
                    </Box>
                </Box>


                <Box component={'section'} className="faq-section bottom-section" sx={{ padding: { sm: '100px 0 0', xs: '0'} }}>
                    <Box className="container">
                        <Grid container className='dir-rtl box-wrapper'>
                            <Grid item sm={9} className='darkblue-rounded-box shadow_box'>
                                <Typography>לא מצאתם את מה שחיפשתם? נציגנו ישמחו לעזור לכם!</Typography>
                                <ActionButton textLabel={`הצג עוד`} className='underline-btn red_text' onClick={() => {
                                    navigate("/contactUs")
                                }} />
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Box>
        </>
    );
}

export default Howto;